import { useModuleBEM, useFlightStyles } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { FlightSteps } from "@b2bportal/core-utilities";
import { useFlightShopBreadcrumbs } from "@tenant/flights";
import { Breadcrumbs } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FlightShopBreadcrumbs.module.scss";

export interface FlightShopBreadcrumbsComponentProps
  extends PlatformComponentProps {
  currentStep: FlightSteps;
}

export const FlightShopBreadcrumbs = ({
  currentStep,
  className,
  children,
}: FlightShopBreadcrumbsComponentProps) => {
  const styles = useFlightStyles(
    CoreFlightsComponent.FlightShopBreadcrumbs,
    defaultStyles
  );
  const [block] = useModuleBEM(
    styles,
    CoreFlightsComponent.FlightShopBreadcrumbs
  );

  const { shopSteps } = useFlightShopBreadcrumbs({
    currentStepId: currentStep,
  });

  return (
    <div className={clsx(block, className)}>
      <Breadcrumbs steps={shopSteps} />
      {children}
    </div>
  );
};
